import React from "react";
import { Input, Text } from "@showitinc/showit-wc";

import { isValidDomain } from "../../../utils/DomainUtils";
import { SOCIAL_LINKS_MAP } from "../../../stores/SiteSettingsStore";
import { formatPropUpdate } from "../../../utils/PropertyUtils";
import styles from "./SiteSettingsModal.module.css";

const _prependHttps = (url) =>
  url === "" || url.slice(0, 8) === "https://" ? url : `https://${url.replace("http://", "")}`;

const _validateUrl = (url) => {
  const error = !url
    ? null
    : !url.slice(0, 8) === "https://"
    ? "URL must use https"
    : !isValidDomain(url)
    ? "Invalid URL"
    : null;
  return { error };
};

const SocialLinks = ({ siteSettings, onChange }) => {
  const config = siteSettings.get("config");
  const socialLinks = {
    slInstagram: config.get("slInstagram", ""),
    slPinterest: config.get("slPinterest", ""),
    slFacebook: config.get("slFacebook", ""),
    slYoutube: config.get("slYoutube", ""),
    slTwitter: config.get("slTwitter", ""),
    slTikTok: config.get("slTikTok", ""),
    slSnapchat: config.get("slSnapchat", ""),
    slLinkedIn: config.get("slLinkedIn", ""),
  };

  const _socialLinkChange = (propInfo) => {
    const updatedPropInfo = {
      ...propInfo,
      value: _prependHttps(propInfo.value),
    };
    onChange(updatedPropInfo);
  };

  return (
    <div>
      <div className={styles.contentHeader}>
        <Text className={styles.title} variant="header-2">
          Social Links
        </Text>
        <Text variant="body-2">
          If your design contains social link placeholders, these URLs will be used.
        </Text>
      </div>

      {Object.entries(socialLinks).map(([prop, val]) => {
        const { error } = _validateUrl(val);
        const label = SOCIAL_LINKS_MAP[prop];
        return (
          <div key={prop}>
            <Input
              className={styles.fullInput}
              label={label}
              fullWidth
              placeholder={`https://${label.toLowerCase()}.com/me`}
              error={error ? { message: error } : false}
              value={val}
              onSIChange={(e) =>
                _socialLinkChange(formatPropUpdate(`config.${prop}`, e.target.value))
              }
              onSIInput={(e) =>
                _socialLinkChange(formatPropUpdate(`config.${prop}`, e.target.value))
              }
            />
          </div>
        );
      })}
    </div>
  );
};

export default SocialLinks;
